<template>
  <div class="library__view">
    <h1 class="library__title">Components</h1>

    <section id="search" class="library__section">
      <b-row>
        <b-col>
          <b-form-group label="Ricerca" label-class="vb-label">
            <vb-input
              v-model="search"
              :vb_options="{
                autocomplete: 'chrome-off',
              }"
            />
          </b-form-group>
        </b-col>
      </b-row>
    </section>

    <!-- section buttons -->
    <section
      id="buttons"
      class="library__section"
      :class="{ 'library__section--hidden': is_hidden('Buttons') }"
    >
      <p class="library__section-title">
        <highlight-match text="Buttons" :search="search" />
      </p>

      <div>
        <vb-button
          class="shadow-lg"
          :vb_options="{
            text: 'large primary',
            variant: 'primary',
            size: 'lg',
          }"
        />

        <span class="mr-3"></span>

        <vb-button
          class="shadow-lg"
          :vb_options="{
            text: 'large secondary',
            variant: 'secondary',
            size: 'lg',
          }"
        />

        <span class="mr-3"></span>

        <vb-button
          class="shadow-lg"
          :vb_options="{
            text: 'large cta',
            variant: 'cta',
            size: 'lg',
          }"
        />

        <span class="mr-3"></span>

        <vb-button
          class="shadow-lg"
          :vb_options="{
            text: 'large vb-color-1',
            variant: 'vb-color-1',
            size: 'lg',
          }"
        />

        <span class="mr-3"></span>

        <vb-button
          class="shadow-lg"
          :vb_options="{
            text: 'large vb-color-2',
            variant: 'vb-color-2',
            size: 'lg',
          }"
        />

        <span class="mr-3"></span>
      </div>

      <div class="mt-4">
        <vb-button
          class="shadow-lg"
          :vb_options="{
            text: 'large info',
            variant: 'info',
            size: 'lg',
          }"
        />

        <span class="mr-3"></span>

        <vb-button
          :vb_options="{
            text: 'large disabled',
            size: 'lg',
            disabled: true,
            icon_disabled: 'lock',
          }"
        />

        <span class="mr-3"></span>

        <vb-button
          class="shadow"
          :vb_options="{
            text: 'default dark',
            variant: 'dark',
          }"
        />

        <span class="mr-3"></span>

        <vb-button
          class="shadow"
          :vb_options="{
            text: 'default icon',
            variant: 'info',
            icon: 'airplane',
          }"
        />

        <span class="mr-3"></span>

        <vb-button
          class="shadow-sm"
          :vb_options="{
            text: 'small light',
            variant: 'light',
            size: 'sm',
          }"
        />

        <span class="mr-3"></span>

        <vb-button
          class="shadow-sm"
          :vb_options="{
            text: 'small outline primary',
            variant: 'outline-primary',
            size: 'sm',
          }"
        />
      </div>
    </section>

    <!-- section radio button -->
    <section
      id="range-slider"
      class="library__section"
      :class="{ 'library__section--hidden': is_hidden('Range slider') }"
    >
      <p class="library__section-title">
        <highlight-match text="Range slider" :search="search" />
      </p>

      <div class="d-flex align-items-center">
        <vb-range-slider
          class="ml-4"
          :vb_options="{
            min: 65,
            max: 2004,
            inputs: true,
            items: Object.values({
              '0': {
                min: '65.60',
                max: '99.96',
                count: 44,
              },
              '100': {
                min: '100.13',
                max: '199.67',
                count: 480,
              },
              '200': {
                min: '200.00',
                max: '299.70',
                count: 378,
              },
              '300': {
                min: '300.00',
                max: '399.00',
                count: 154,
              },
              '400': {
                min: '400.51',
                max: '499.98',
                count: 80,
              },
              '500': {
                min: '500.00',
                max: '599.00',
                count: 53,
              },
              '600': {
                min: '601.82',
                max: '698.70',
                count: 26,
              },
              '700': {
                min: '704.34',
                max: '798.62',
                count: 10,
              },
              '800': {
                min: '801.90',
                max: '891.00',
                count: 17,
              },
              '900': {
                min: '900.00',
                max: '991.97',
                count: 7,
              },
              '1000': {
                min: '1000.00',
                max: '1086.75',
                count: 3,
              },
              '1100': {
                min: '1101.61',
                max: '1193.51',
                count: 5,
              },
              '1200': {
                min: '1203.80',
                max: '1222.66',
                count: 3,
              },
              '1300': {
                min: '1310.62',
                max: '1356.54',
                count: 2,
              },
              '1400': {
                min: '1440.00',
                max: '1456.55',
                count: 2,
              },
              '1500': {
                min: '1500.00',
                max: '1561.45',
                count: 4,
              },
              '1600': {
                min: '1619.20',
                max: '1619.20',
                count: 1,
              },
              '1700': {
                min: '1715.00',
                max: '1715.00',
                count: 1,
              },
              '1800': {
                min: '1800.00',
                max: '1897.71',
                count: 4,
              },
              '1900': {
                min: '1932.30',
                max: '1949.38',
                count: 2,
              },
              '2000': {
                min: '2003.11',
                max: '2003.11',
                count: 1,
              },
            }),
          }"
        />

        <vb-range-slider
          class="ml-4"
          :vb_options="{
            inputs: true,
            min: 55,
            max: 1680,
            items: Object.values({
              0: {
                count: 19,
              },
              100: {
                count: 279,
              },
              200: {
                count: 250,
              },
              300: {
                count: 127,
              },
              400: {
                count: 45,
              },
              500: {
                count: 26,
              },
              600: {
                count: 21,
              },
              700: {
                count: 9,
              },
              800: {
                count: 2,
              },
              900: {
                count: 2,
              },
              1000: {
                count: 1,
              },
              1100: {
                count: 2,
              },
              1300: {
                count: 3,
              },
              1400: {
                count: 4,
              },
              1600: {
                count: 2,
              },
            }),
          }"
        />
      </div>
    </section>

    <!-- section steps bar -->
    <section
      id="steps-bar"
      class="library__section"
      :class="{ 'library__section--hidden': is_hidden('Steps bar') }"
    >
      <p class="library__section-title">
        <highlight-match text="Steps bar" :search="search" />
      </p>

      <div class="steps-demo__control d-flex flex-wrap align-items-end mb-3">
        <b-form-group
          class="mb-0 mr-3"
          label="Numero di step"
          label-for="steps-demo-count"
          label-class="vb-label"
        >
          <b-form-input
            id="steps-demo-count"
            v-model.number="step_count"
            class="steps-demo__count"
            type="number"
            min="1"
            max="12"
          />
        </b-form-group>

        <b-form-group
          class="mb-0 mr-3"
          label="Allineamento"
          label-for="steps-demo-alignment"
          label-class="vb-label"
        >
          <vb-select
            :vb_options="{
              id: 'steps-demo-alignment',
              options: alignment_options,
              value: steps_alignment,
            }"
            @change="steps_alignment = $event"
          />
        </b-form-group>

        <b-form-group
          class="mb-0 mr-3"
          label="Colore"
          label-for="steps-demo-color"
          label-class="vb-label"
        >
          <vb-select
            :vb_options="{
              id: 'steps-demo-color',
              options: color_options,
              value: steps_color,
            }"
            @change="steps_color = $event"
          />
        </b-form-group>

        <b-form-group
          v-if="steps_color === 'custom'"
          class="mb-0 mr-3"
          label="Colore personalizzato"
          label-for="steps-demo-custom-color"
          label-class="vb-label"
        >
          <b-form-input
            id="steps-demo-custom-color"
            v-model="steps_custom_color"
            class="steps-demo__color"
            type="color"
          />
        </b-form-group>

        <b-form-group
          class="mb-0 mr-3"
          label="Simbolo (px)"
          label-for="steps-demo-symbol-size"
          label-class="vb-label"
        >
          <b-form-input
            id="steps-demo-symbol-size"
            v-model.number="steps_symbol_size"
            class="steps-demo__count"
            type="number"
            min="12"
            max="60"
          />
        </b-form-group>

        <b-form-group
          class="mb-0 mr-3"
          label="Linea (px)"
          label-for="steps-demo-line-thickness"
          label-class="vb-label"
        >
          <b-form-input
            id="steps-demo-line-thickness"
            v-model.number="steps_line_thickness"
            class="steps-demo__count"
            type="number"
            min="1"
            max="12"
            step="0.5"
          />
        </b-form-group>

        <vb-button
          :vb_options="{ text: 'Applica', variant: 'info' }"
          @click="build_steps_demo"
        />
      </div>

      <steps-bar
        :steps="steps_demo"
        :active_id="active_step_id"
        :enabled_ids="visited_step_ids"
        :completed_ids="completed_step_ids"
        :customizations="steps_customizations"
        @select="set_active_step"
      />

      <div v-if="active_step" class="steps-demo__body">
        <p class="steps-demo__heading">
          <b>{{ active_step.name }}</b> di {{ steps_demo.length }}
        </p>
        <p class="text--muted text--small mb-3">
          Attiva il requisito per sbloccare il pulsante «Continua».
        </p>

        <vb-checkbox
          :key="`${active_step_id}-${reset_token}`"
          :vb_options="{
            switch: true,
            type: 'light',
            text: 'Requisiti dello step soddisfatti',
            value: step_gates[active_step_id],
          }"
          @change="set_step_gate(active_step_id, $event)"
        />

        <div class="steps-demo__actions mt-4">
          <vb-button
            :vb_options="{
              text: 'Indietro',
              variant: 'light',
              disabled: active_step_index === 0,
            }"
            @click="go_back"
          />

          <span class="mr-2"></span>

          <vb-button
            :vb_options="{
              text: continue_label,
              variant: 'primary',
              disabled: !can_continue,
            }"
            @click="advance"
          />

          <span class="mr-2"></span>

          <vb-button
            :vb_options="{ text: 'Reset', variant: 'outline-primary' }"
            @click="reset_steps_demo"
          />
        </div>
      </div>
    </section>

    <!-- section radio button -->
    <section
      id="radio"
      class="library__section"
      :class="{ 'library__section--hidden': is_hidden('Radio') }"
    >
      <p class="library__section-title">
        <highlight-match text="Radio" :search="search" />
      </p>

      <div class="d-flex align-items-center">
        <vb-radio
          :vb_options="{
            text: 'Radio default',
            size: 'sm',
          }"
        />

        <span class="mr-3"></span>

        <vb-radio
          :vb_options="{
            text: 'Radio disabled',
            disabled: true,
          }"
        />

        <span class="mr-3"></span>

        <vb-radio
          :vb_options="{
            text: 'Radio light default',
            type: 'light',
          }"
        />

        <span class="mr-3"></span>

        <vb-radio
          :vb_options="{
            text: 'Radio light disabled',
            type: 'light',
            disabled: true,
          }"
        />
      </div>
    </section>

    <!-- section checkbox -->
    <section
      id="checkbox"
      class="library__section"
      :class="{ 'library__section--hidden': is_hidden('Checkbox') }"
    >
      <p class="library__section-title">
        <highlight-match text="Checkbox" :search="search" />
      </p>

      <div class="d-flex align-items-center">
        <vb-checkbox
          :vb_options="{
            text: 'Checkbox default',
          }"
        />

        <span class="mr-3"></span>

        <vb-checkbox
          :vb_options="{
            text: 'Checkbox disabled',
            disabled: true,
          }"
        />

        <span class="mr-3"></span>

        <vb-checkbox
          :vb_options="{
            text: 'Checkbox light default',
            type: 'light',
          }"
        />

        <span class="mr-3"></span>

        <vb-checkbox
          :vb_options="{
            text: 'Checkbox light disabled',
            type: 'light',
            disabled: true,
          }"
        />
      </div>
    </section>

    <!-- section switch -->
    <section
      id="switch"
      class="library__section"
      :class="{ 'library__section--hidden': is_hidden('Switch') }"
    >
      <p class="library__section-title">
        <highlight-match text="Switch" :search="search" />
      </p>

      <div class="d-flex align-items-center">
        <vb-checkbox
          :vb_options="{
            text: 'Switch default',
            switch: true,
          }"
        />

        <span class="mr-3"></span>

        <vb-checkbox
          :vb_options="{
            text: 'Switch disabled',
            disabled: true,
            switch: true,
          }"
        />

        <span class="mr-3"></span>

        <vb-checkbox
          :vb_options="{
            text: 'Switch light default',
            switch: true,
            type: 'light',
          }"
        />

        <span class="mr-3"></span>

        <vb-checkbox
          :vb_options="{
            text: 'Switch light disabled',
            disabled: true,
            switch: true,
            type: 'light',
          }"
        />
      </div>
    </section>

    <!-- section input -->
    <section
      id="input"
      class="library__section"
      :class="{ 'library__section--hidden': is_hidden('Type Input') }"
    >
      <p class="library__section-title">
        <highlight-match text="Type Input" :search="search" />
      </p>

      <div class="w-50">
        <vb-input
          :vb_options="{
            placeholder: 'Placeholder',
          }"
        />
      </div>

      <hr class="mt-4" />

      <div class="w-50">
        <vb-input
          v-model="money"
          :vb_options="{
            required: true,
            name: 'Valore del buono',
            price: true,
            value: null,
            placeholder: '1234',
            formatter: format_price,
          }"
        />
        <small class="mb-1"
          ><i>Valore realmente gestito: </i><b>{{ money }}</b></small
        >
      </div>
    </section>

    <!-- section select -->
    <section
      id="select"
      class="library__section"
      :class="{ 'library__section--hidden': is_hidden('Select') }"
    >
      <p class="library__section-title">
        <highlight-match text="Select" :search="search" />
      </p>

      <div class="w-50">
        <b-form-group
          label-for="select"
          label="Label select"
          label-class="vb-label"
        >
          <vb-select
            :vb_options="{
              options: [
                { item: null, name: 'Please select an option', disabled: true },
                { item: 'A', name: 'Option A' },
                { item: 'B', name: 'Option B' },
              ],
              value_field: 'item',
              text_field: 'name',
              value: null,
            }"
          />
        </b-form-group>
      </div>

      <hr class="mt-4" />

      <b-form inline class="vb-form">
        <b-form-group
          label-for="select"
          label="Label select inline"
          label-class="vb-label"
        >
          <vb-select
            :vb_options="{
              options: [
                { item: null, name: 'Please select an option', disabled: true },
                { item: 'A', name: 'Option A' },
                { item: 'B', name: 'Option B' },
              ],
              value_field: 'item',
              text_field: 'name',
              value: null,
            }"
          />
        </b-form-group>
      </b-form>
    </section>

    <!-- section breadcrumbs-->
    <section
      id="breadcrumbs"
      class="library__section"
      :class="{ 'library__section--hidden': is_hidden('Breadcrumbs') }"
    >
      <p class="library__section-title">
        <highlight-match text="Breadcrumbs" :search="search" />
      </p>

      <vb-breadcrumbs
        :vb_options="{
          items: [
            {
              text: 'Home',
              href: '#',
            },
            {
              text: 'Travel',
              href: '#',
            },
            {
              text: 'Paris',
              active: true,
            },
          ],
        }"
      />
    </section>

    <!-- section tabs-->
    <section
      id="tabs"
      class="library__section"
      :class="{ 'library__section--hidden': is_hidden('Tabs') }"
    >
      <p class="library__section-title">
        <highlight-match text="Tabs" :search="search" />
      </p>

      <div class="w-50">
        <vb-tabs>
          <b-tab title="Tab 01">
            <p>I'm the first tab</p>
          </b-tab>
          <b-tab title="Tab 02">
            <p>I'm the second tab</p>
          </b-tab>
        </vb-tabs>
      </div>
    </section>

    <!-- section toggle -->
    <section
      id="toggle"
      class="library__section"
      :class="{ 'library__section--hidden': is_hidden('Toggle') }"
    >
      <p class="library__section-title">
        <highlight-match text="Toggle" :search="search" />
      </p>

      <div class="w-50">
        <vb-toggle
          :vb_options="{
            id: 'my-toggle',
            btn_text: 'Toggle Collapse',
          }"
        >
          <p>Hello World</p>
        </vb-toggle>
      </div>
    </section>

    <!-- section modal -->
    <section
      id="modal"
      class="library__section"
      :class="{ 'library__section--hidden': is_hidden('Modal') }"
    >
      <p class="library__section-title">
        <highlight-match text="Modal" :search="search" />
      </p>

      <span class="text-info" v-b-modal="'modal_library'">open modal</span>

      <vb-modal
        :vb_options="{
          id: 'modal_library',
          size: 'lg',
          title: 'I pacchetti viaggio includono',
          hide_footer: true,
        }"
      >
        <p>
          Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam
          nonummy nibh euismod tincidunt ut laore et dolore magna aliquam erat
          volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation
          ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo consequat.
        </p>
      </vb-modal>
    </section>

    <!-- section dropdown -->
    <section
      id="dropdown"
      class="library__section"
      :class="{ 'library__section--hidden': is_hidden('Dropdown') }"
    >
      <p class="library__section-title">
        <highlight-match text="Dropdown" :search="search" />
      </p>

      <vb-dropdown
        :vb_options="{
          size: 'lg',
          text: 'large info',
        }"
      >
        <b-dropdown-item>First Action</b-dropdown-item>
        <b-dropdown-item>Second Action</b-dropdown-item>
        <b-dropdown-item>Third Action</b-dropdown-item>
        <b-dropdown-divider></b-dropdown-divider>
        <b-dropdown-item>Something else here...</b-dropdown-item>
        <b-dropdown-item active>Active action</b-dropdown-item>
        <b-dropdown-item disabled>Disabled action</b-dropdown-item>
      </vb-dropdown>

      <span class="mr-3"></span>

      <vb-dropdown
        :vb_options="{
          variant: 'outline-primary',
          text: 'default outline primary',
        }"
      >
        <b-dropdown-item>First Action</b-dropdown-item>
        <b-dropdown-item>Second Action</b-dropdown-item>
        <b-dropdown-item>Third Action</b-dropdown-item>
        <b-dropdown-divider></b-dropdown-divider>
        <b-dropdown-item>Something else here...</b-dropdown-item>
        <b-dropdown-item active>Active action</b-dropdown-item>
        <b-dropdown-item disabled>Disabled action</b-dropdown-item>
      </vb-dropdown>
    </section>

    <!-- section card default (vertical)  -->
    <section
      id="cards"
      class="library__section"
      :class="{ 'library__section--hidden': is_hidden('Card Default (Vertical)') }"
    >
      <p class="library__section-title">
        <highlight-match text="Card Default (Vertical)" :search="search" />
      </p>

      <b-row>
        <b-col cols="4">
          <vb-card
            :card="{
              title: 'Title',
              subtitle: 'SubTitle',
              text: 'Sed posuere consectetur est at lobor-tis. Aenean eu leo quam. Pellentesque ornare sem lacinia quam venenatis vestibulum.',
              image: '/assets/images/alpitour/statics/iStock-1208856002.jpg',
            }"
          />
        </b-col>
        <b-col cols="4">
          <vb-card
            :card="{
              title: 'Title',
              subtitle: 'SubTitle',
              text: 'Sed posuere consectetur est at lobor-tis. Aenean eu leo quam. Pellentesque ornare sem lacinia quam venenatis vestibulum.',
              image: '/assets/images/alpitour/statics/iStock-1208856002.jpg',
            }"
          />
        </b-col>
        <b-col cols="4">
          <vb-card
            :card="{
              title: 'Title',
              subtitle: 'SubTitle',
              text: 'Sed posuere consectetur est at lobor-tis. Aenean eu leo quam. Pellentesque ornare sem lacinia quam venenatis vestibulum.',
              image: '/assets/images/alpitour/statics/iStock-1208856002.jpg',
            }"
          />
        </b-col>
      </b-row>
    </section>

    <!-- section card -->
    <section
      class="library__section"
      :class="{ 'library__section--hidden': is_hidden('Card Horizontal') }"
    >
      <p class="library__section-title">
        <highlight-match text="Card Horizontal" :search="search" />
      </p>

      <div class="w-50">
        <vb-card
          variant="horizontal"
          :card="{
            title: 'Title',
            subtitle: 'SubTitle',
            text: 'Sed posuere consectetur est at lobor-tis. Aenean eu leo quam. Pellentesque ornare sem lacinia quam venenatis vestibulum.',
            image: '/assets/images/alpitour/statics/iStock-1208856002.jpg',
          }"
        >
          <div class="mt-3">
            <a href="#">Slot content</a>
          </div>
        </vb-card>
      </div>
    </section>

    <!-- popover -->
    <section
      class="library__section"
      :class="{ 'library__section--hidden': is_hidden('Popovers') }"
    >
      <p class="library__section-title">
        <highlight-match text="Popovers" :search="search" />
        <vb-checkbox
          class="text--base"
          @change="toggle_popover_with_arrow"
          :vb_options="{
            text: 'Mostra versione senza punta',
            switch: with_arrow,
            type: 'light',
          }"
        />
        <span class="text--muted text--small">
          Nota: Se lo schermo non permette di vedere tutto il corpo del popover la libreria di bootstrap lo posizionerà in modalità auto
        </span>
      </p>
      <b-row>
        <b-col
          v-for="popover_example in popovers"
          :key="`popover:${popover_example.variant}:${popover_example.placement}`"
          cols="3"
        >
          <div class="custom-popover">
            <div
              :id="`popover:${popover_example.variant}:${popover_example.placement}`"
              class="custom-popover--trigger"
            >
              popover {{ popover_example.variant }}
              {{ popover_example.placement }}
            </div>
            <b-popover
              :target="`popover:${popover_example.variant}:${popover_example.placement}`"
              triggers="hover"
              :placement="popover_example.placement"
              :custom-class="`b-popover--${popover_example.variant} ${with_arrow ? '' : 'b-popover--no-arrow'}`"
            >
              Popover content
            </b-popover>
          </div>
        </b-col>
      </b-row>
    </section>

    <!-- loader -->
    <section
      class="library__section"
      :class="{ 'library__section--hidden': is_hidden('Loaders') }"
    >
      <p class="library__section-title">
        <highlight-match text="Loaders" :search="search" />
      </p>
      <b-row>
        <b-col cols="2">
          <p class="text--small text--muted mb-2 d-flex align-items-center">default <loader class="ml-3" /></p>
        </b-col>
        <b-col cols="2">
          <p class="text--small text--muted mb-2 d-flex align-items-center">small <loader class="ml-3" size="small" /></p>
        </b-col>
        <b-col cols="2">
          <p class="text--small text--muted mb-2 d-flex align-items-center">large <loader class="ml-3" size="large" /></p>
        </b-col>
      </b-row>
      <b-row class="mt-4 pt-2">
        <b-col cols="6">
          <p class="text-center text--small text--muted mb-4"><i>Timing slot</i> (default)</p>
          <loader size="large"
            :show_timing_slot="true"
          />
        </b-col>
        <b-col cols="6">
          <p class="text-center text--small text--muted mb-4"><i>Timing slot</i> (custom)</p>
          <loader
            size="large"
            :show_timing_slot="true"
            :text_loading="loading_messages.book.messages"
            :text_footer="loading_messages.book.footer"
          />
        </b-col>
      </b-row>
      <b-row class="mt-4">
        <b-col cols="12">
          <p class="text--small text--muted mb-2">loader in modal (fullscreen blocking)</p>
          <vb-button
            :vb_options="{ text: 'Mostra loader-modal', variant: 'info' }"
            @click="show_loader_modal = true"
          />
          <vb-button
            v-if="show_loader_modal"
            class="ml-2"
            :vb_options="{ text: 'Chiudi (debug)', variant: 'light' }"
            @click="show_loader_modal = false"
          />
          <loader-modal :show="show_loader_modal" service="book" />
        </b-col>
      </b-row>
    </section>

    <!-- section image with text cta -->
    <!--    <section class="library__section">
      <p class="library__section-title">Image with text cta</p>

      <div class="w-50">
        <image-with-text-cta
            :image_src="'assets/images/alpitour/statics/iStock-1180231917.jpg'"
            :text_heading="'Welfare non sufficiente?'"
            :text_content="'Se il tuo credito welfare non è sufficiente troviamo insieme una soluzione. <strong>Parliamo!</strong>'"
            :text_cta="[
              {
                cta_text: 'Chat',
                cta_icon: 'symbol_lb',
                cta_action: 'support',
                cta_id: 'library-demo-chat',
              },
              {
                cta_text: 'Whatsapp',
                cta_icon: 'whatsapp',
                cta_url: '#',
              },
              {
                cta_text: 'Email',
                cta_icon: 'mail',
                cta_url: 'mailto:',
              }
            ]"
        />
      </div>

    </section>-->
  </div>
</template>

<script>
import { loading_messages } from "@/resources";
import StepsBar from "../blocks/steps-bar.vue";
import HighlightMatch from "../blocks/highlight-match.vue";

export default {
  name: "components",
  components: {
    "steps-bar": StepsBar,
    "highlight-match": HighlightMatch,
  },
  data() {
    return {
      search: "",
      with_arrow: true,
      money: 0,

      step_count: 4,
      steps_demo: [],
      active_step_id: "",
      visited_step_ids: [],
      completed_step_ids: [],
      step_gates: {},
      reset_token: 0,

      steps_alignment: "row",
      steps_color: "var(--primary)",
      steps_custom_color: "#0d6efd",
      steps_symbol_size: 25,
      steps_line_thickness: 2.5,
      alignment_options: [
        { value: "row", text: "Simbolo → etichetta" },
        { value: "row-reverse", text: "Etichetta → simbolo" },
        { value: "column", text: "Simbolo sopra etichetta" },
        { value: "column-reverse", text: "Etichetta sopra simbolo" },
      ],
      color_options: [
        { value: "var(--primary)", text: "Primary" },
        { value: "var(--secondary)", text: "Secondary" },
        { value: "var(--success)", text: "Success" },
        { value: "var(--info)", text: "Info" },
        { value: "var(--warning)", text: "Warning" },
        { value: "custom", text: "Custom…" },
      ],

      popovers: ["default", "dark", "primary", "secondary", "info", "danger"].flatMap(
        (variant) =>
          ["top", "bottom", "left", "right"].map((placement) => ({
            placement,
            variant,
          }))
      ),

      loading_messages,
      show_loader_modal: false,
    };
  },
  computed: {
    steps_customizations() {
      let steps_color = this.steps_color;
      if (this.steps_color === "custom") steps_color = this.steps_custom_color;
      return {
        steps_alignment: this.steps_alignment,
        steps_color,
        symbol_size: `${this.steps_symbol_size}px`,
        line_thickness: `${this.steps_line_thickness}px`,
      };
    },
    active_step() {
      return this.steps_demo.find((s) => s.id === this.active_step_id) || null;
    },
    active_step_index() {
      return this.steps_demo.findIndex((s) => s.id === this.active_step_id);
    },
    is_last_step() {
      return this.active_step_index === this.steps_demo.length - 1;
    },
    can_continue() {
      return this.step_gates[this.active_step_id] === true;
    },
    continue_label() {
      return this.is_last_step ? "Completa" : "Continua";
    },
  },
  created() {
    this.build_steps_demo();
  },
  methods: {
    is_hidden(title) {
      if (!this.search) return false;
      return !title.toLowerCase().includes(this.search.toLowerCase());
    },
    toggle_popover_with_arrow() {
      this.with_arrow = !this.with_arrow;
    },
    build_steps_demo() {
      const count = Math.min(12, Math.max(1, Number(this.step_count) || 1));
      this.step_count = count;
      this.steps_demo = Array.from({ length: count }, (_, index) => ({
        id: `step-${index + 1}`,
        name: `Step ${index + 1}`,
      }));
      this.reset_steps_demo();
    },
    set_active_step(step_id) {
      if (!step_id || step_id === this.active_step_id) return;
      if (this.visited_step_ids.indexOf(step_id) < 0) return;
      this.active_step_id = step_id;
    },
    set_step_gate(step_id, value) {
      this.step_gates = { ...this.step_gates, [step_id]: value };
    },
    mark_completed(step_id) {
      if (!step_id) return;
      if (this.completed_step_ids.indexOf(step_id) >= 0) return;
      this.completed_step_ids = [...this.completed_step_ids, step_id];
    },
    advance() {
      if (!this.can_continue) return;
      this.mark_completed(this.active_step_id);
      if (this.is_last_step) return;
      const next_step = this.steps_demo[this.active_step_index + 1];
      if (this.visited_step_ids.indexOf(next_step.id) < 0) {
        this.visited_step_ids = [...this.visited_step_ids, next_step.id];
      }
      this.active_step_id = next_step.id;
    },
    go_back() {
      if (this.active_step_index <= 0) return;
      this.active_step_id = this.steps_demo[this.active_step_index - 1].id;
    },
    reset_steps_demo() {
      const first_step = this.steps_demo[0];
      this.active_step_id = first_step ? first_step.id : "";
      this.visited_step_ids = first_step ? [first_step.id] : [];
      this.completed_step_ids = [];
      this.step_gates = this.steps_demo.reduce((gates, step) => {
        gates[step.id] = false;
        return gates;
      }, {});
      this.reset_token += 1;
    },
  },
};
</script>

<style lang="scss">
.library__section--hidden {
  display: none;
}

.steps-demo {
  &__body {
    background-color: $white;
    border-radius: 10px;
    padding: 20px;
  }

  &__heading {
    margin-bottom: 5px;
  }

  &__count {
    max-width: 90px;
  }

  &__color {
    padding: 4px;
  }
}

.custom-popover {
  display: flex;
  justify-content: center;
  margin-bottom: 30px;
  border-radius: 10px;
  background-color: white; 
  &--trigger {
    padding: 15px;
  }
}
</style>
